import { formatAppRouter } from '@Core/Helpers/System'
import { quizExamRouterConfig } from './Modules/Exam/configs/router'
import { orderRouterConfig } from './Modules/Order/configs/router'

export const quizRouterConfig = formatAppRouter([quizExamRouterConfig, orderRouterConfig])
